import { cacheService, detailedSearchActions } from '../../services';
import { validateResponse } from '../../util/authenticatonValidation';

export const detailedSearchDispatcher = dispatch => ( {
  searchProducts( query, pageResult, pageSize = 20, hasStockFilter ) {
    // first reset
    dispatch( { type: 'dispatch-busy', action: 'search-active' } );
    return cacheService( 'detailedSearch' ).post( {
      page: pageResult ? pageResult.page : 0,
      pageSize: pageSize,
      request: {query : query?.query || query, hasStockFilter : hasStockFilter}
    } )
      .then( validateResponse( dispatch ) ).then( response => dispatch( { type: detailedSearchActions.LOAD, data: response.data } ) ).then(res=>dispatch( { type: 'dispatch-complete', action: 'search-active' } ))
      .catch(e=>dispatch( { type: 'dispatch-complete', action: 'search-active' } ));
  }
} );